// extracted by mini-css-extract-plugin
export var details = "ParagraphGroupOfExpandableSections-module--details--f7329";
export var expandablesection = "ParagraphGroupOfExpandableSections-module--expandablesection--0b676";
export var headercontainer = "ParagraphGroupOfExpandableSections-module--headercontainer--27db4";
export var imagecontainer = "ParagraphGroupOfExpandableSections-module--imagecontainer--c9fe1";